import {isolarAnalyticsSimpleData} from '../../meter/isolarAnalyticsSimpleData';

/**
 * Created by oleturvoll on 5/5/17.
 */

export class ng2ChartJs {

  //TODO: not sure we need this class or can do with the interface
  saData: isolarAnalyticsSimpleData[];
  row: number;
  column: number = 4;  // effectively a const for this datatype
  timestamps: string[];
  generatedAndConsumed: any[];
  netAndInaccurate: any[];


  titleOptions: any = {
    display: true,
    text: '30 day energy usage(kWh)'
  };

  titleOptions2: any = {
    display: true,
    text: 'Net Energy and Inaccuracy of prediction(kWh)'
  };

  lineChartColors: any[] = [
    { // light yellow
      backgroundColor: 'rgba(255,241,118,0.2)',
      borderColor: 'rgba(255,241,118,1)',
      pointBackgroundColor: 'rgba(255,241,118,1)',
      pointBorderColor: '#fff176',
      pointHoverBackgroundColor: '#fff176',
      pointHoverBorderColor: 'rgba(255,241,118,1)'
    },{ // grey
      backgroundColor: 'rgba(97,97,97,0.2)',
      borderColor: 'rgba(97,97,97,1)',
      pointBackgroundColor: 'rgba(97,97,97,1)',
      pointBorderColor: '#616161',
      pointHoverBackgroundColor: '#616161',
      pointHoverBorderColor: 'rgba(97,97,97,0.8)'
    },

    { // orange
      backgroundColor: 'rgba(255,152,0,0.2)',
      borderColor: 'rgba(255,152,0,1)',
      pointBackgroundColor: 'rgba(255,152,0,1)',
      pointBorderColor: '#ff9800',
      pointHoverBackgroundColor: '#ff9800',
      pointHoverBorderColor: 'rgba(255,152,0,0.8)'
    }
  ];

  barChartColors: any[] = [
    { // grey
      backgroundColor: 'rgba(97,97,97,0.2)',
      borderColor: 'rgba(97,97,97,1)',
      pointBackgroundColor: 'rgba(97,97,97,1)',
      pointBorderColor: '#616161',
      pointHoverBackgroundColor: '#616161',
      pointHoverBorderColor: 'rgba(97,97,97,0.8)'
    },
    { // orange
      backgroundColor: 'rgba(255,152,0,0.2)',
      borderColor: 'rgba(255,152,0,1)',
      pointBackgroundColor: 'rgba(255,152,0,1)',
      pointBorderColor: '#ff9800',
      pointHoverBackgroundColor: '#ff9800',
      pointHoverBorderColor: 'rgba(255,152,0,0.8)'
    }
  ];

  // Container for pan doughnutOptions
  pan: any = {
    enabled: true,
    mode: 'xy',
    speed: 10,
    threshold: 10
  };

  // Container for zoom doughnutOptions
  zoom: any ={
    enabled: true,
    mode: 'x',
    drag: true,
    // limits: {
    //   max: 10,
    //   min: 0.5
    // }
  };


  displayOptions2: any = {
    title: this.titleOptions2,
    // zoom: this.zoom,
    // pan: this.pan,
  };

  displayOptions: any = {
    title: this.titleOptions,
    // zoom: this.zoom,
    // pan: this.pan,
  };

  chartOptions2: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    title: this.titleOptions2,
    // zoom: this.zoom,
    // pan: this.pan
  };

  chartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    title: this.titleOptions,
    // zoom: this.zoom,
    // pan: this.pan
  };

  chartType: string = 'line';
  chartLegend: boolean = true;


  constructor(data: isolarAnalyticsSimpleData[]){
    this.saData = data;
    this.row = data.length;
    this.timestamps = this.getXAxis();
    this.generatedAndConsumed = this.getYAxes();
    this.netAndInaccurate = this.getNetAndAccuracy();
  }

  private getOne(num: number): isolarAnalyticsSimpleData{
      return this.saData[num];
  }

  private getDay(num: number): string{
    return this.getOne(num).t_stamp;
  }

  getXAxis(): string[]{

    let dayData:string[] = [];
    for(let num in this.saData){
      // this.logger.log.debug(this.getDay(Number(num)));
      dayData.push(this.getDay(Number(num)));
    }
    return dayData;

  }

  private getGeneratedDataOne(num: number, kWh?: boolean): number{
    if(kWh === false){
    return this.getOne(num).energy_generated;
    } else {
      return Number((this.getOne(num).energy_generated /1000).toFixed(3));
    }
  }

  private getConsumedDataOne(num: number, kWh?: boolean): number{
    if(kWh === false){
    return this.getOne(num).energy_consumed;
    } else {
      return Number((this.getOne(num).energy_consumed /1000).toFixed(3));
    }
  }

  private getNetDataOne(num: number, kWh?: boolean): number{
    let myData:isolarAnalyticsSimpleData = this.getOne(num);
    let net: number = myData.energy_generated-myData.energy_consumed;
    if(kWh === false){
      return net;
    } else {
      return Number((net/1000).toFixed(3));
    }
  }


  private getPredictionAccuracyDataOne(num: number, kWh?: boolean): number{
    let myData:isolarAnalyticsSimpleData = this.getOne(num);
    let net: number = myData.energy_generated-myData.energy_expected;
    if(kWh === false){
      return net;
    } else {
      return Number((net/1000).toFixed(3));
    }
  }



  private getGeneratedData(): number[]{
    let generatedDataSet:number[] = [];
    for(let num in this.saData){
      // this.logger.log.debug(this.getDay(Number(num)));
      generatedDataSet.push(this.getGeneratedDataOne(Number(num)));
    }

    return generatedDataSet;
  }

  private getConsumedData(): number[]{
    let consumedDataSet:number[] = [];
    for(let num in this.saData){
      // this.logger.log.debug(this.getDay(Number(num)));
      consumedDataSet.push(this.getConsumedDataOne(Number(num)));
    }

    return consumedDataSet;
  }

  private getNetData(): number[]{
    let netDataSet:number[] = [];
    for(let num in this.saData){
      netDataSet.push(this.getNetDataOne(Number(num)));
    }

    return netDataSet;
  }


  getYAxes(): any[]{

    return [
      { data: this.getGeneratedData(), label: 'Generated Data' },
      { data: this.getConsumedData(), label: 'Consumed Data' }
    ];

  }

  getNetAndAccuracy(): any[]{
    return [
      { data: this.getNetData(), label: 'Net Energy'},
      { data: this.getPredictionAccuracyData(), label: 'Prediction Error'}
    ];
  }

  getNetEnergy(): any[]{
    return [
      { data: this.getNetData(), label: 'Net Energy'}
    ];
  }


  private getPredictionAccuracyData(): number[]{
    let predictionAccuracyDataSet:number[] = [];
    for(let num in this.saData){
      predictionAccuracyDataSet.push(this.getPredictionAccuracyDataOne(Number(num)));
    }

    return predictionAccuracyDataSet;
  }

  getPredictionAccuracy(): any[]{
    return [
      { data: this.getPredictionAccuracyData(), label: 'Prediction Error'}
    ];
  }
}



// WEBPACK FOOTER //
// ./src/model/graphing/ng2chart/ng2ChartJs.ts